import {
  CardIssuingIcon,
  LocationsIcon,
  ReportsIcon,
  SettingsIcon,
} from "../assets/icons/Icons";

import {
  MOD_AUDIT_LOGS,
  MOD_BATCH_SELL_ORDER,
  MOD_CARD_BALANCE,
  MOD_CARD_HOLDERS,
  MOD_CARD_ISSUING,
  MOD_CORPORATE_CUSTOMERS,
  MOD_KIOSK_REPORT,
  MOD_OFFICE,
  MOD_ORDER,
  MOD_PROGRAMS,
  MOD_REPLACE_CARDS,
  MOD_REPORT,
  MOD_REPORTS,
  MOD_SEARCH_ORDER,
  MOD_SELL_ORDER,
  MOD_SHIFT_REPORT,
  MOD_SHIPPING_ADDRESS,
  MOD_USERS,
  MOD_VOID_CARDS,
  MOD_COMBINE_CARDS,
  MOD_SELL_SPECIALTY_ITEMS
} from "../contstants";

// Components
import Users from "../pages/settings/users";
import AuditLogs from "../pages/settings/audit-logs";
import CorporateCustomers from "../pages/settings/corporate-customers";
import SellSpecialtyItems from "../pages/settings/sell-specialty-items";
import ShippingAddresses from "../pages/offices/shipping-addresses";
import Reports from "../pages/reports";
import CheckCardBalance from "../pages/card-issuing/check-card-balance";
import ReplaceCards from "../pages/card-issuing/replace-cards";
import ShiftReport from "../pages/card-issuing/shift-report";
import KioskReport from "../pages/card-issuing/kiosk-report";
import BatchOrders from "../pages/card-issuing/batch-orders";
import CardOrders from "../pages/card-issuing/orders";
import SearchOrder from "../pages/card-issuing/searchorder";
import Offices from "../pages/offices";
import SellOrders from "../pages/card-issuing/sell-orders";
import VoidCards from "../pages/card-issuing/void-cards";
import CardIssuing from "../pages/card-issuing";
import Programs from "../pages/card-issuing/programs";
import CardHolders from "../pages/card-issuing/cardholders";
import ProgramReports from "../pages/program-reports";
import CombineCards from "../pages/card-issuing/combine-cards";

export const appModules = [
  {
    label: "Card Issuing",
    icon: CardIssuingIcon,
    path: "/card-issuing",
    module: MOD_CARD_ISSUING,
    permission: { [MOD_CARD_ISSUING]: "read" },
    allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
    element: <CardIssuing />,
    children: [
      {
        label: "Cardholders",
        path: "/card-issuing/cardholders",
        module: MOD_CARD_HOLDERS,
        permission: { [MOD_CARD_HOLDERS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <CardHolders />,
      },
      {
        label: "Programs",
        path: "/card-issuing/programs",
        module: MOD_PROGRAMS,
        permission: { [MOD_PROGRAMS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <Programs />,
      },
      {
        label: "Orders",
        path: "/card-issuing/orders",
        module: MOD_ORDER,
        permission: { [MOD_ORDER]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <CardOrders />,
      },
      {
        label: "Search by Proxy",
        path: "/card-issuing/searchorder",
        module: MOD_SEARCH_ORDER,
        permission: { [MOD_SEARCH_ORDER]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <SearchOrder />,
      },
      {
        label: "Sell Orders",
        path: "/card-issuing/sell-orders",
        module: MOD_SELL_ORDER,
        permission: { [MOD_SELL_ORDER]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <SellOrders />,
      },
      {
        label: "Void Card",
        path: "/card-issuing/void-cards",
        module: MOD_VOID_CARDS,
        permission: { [MOD_VOID_CARDS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin"],
        element: <VoidCards />,
      },
      {
        label: "Batch Sell Orders",
        path: "/card-issuing/batch-order",
        module: MOD_BATCH_SELL_ORDER,
        permission: { [MOD_BATCH_SELL_ORDER]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <BatchOrders />,
      },
      {
        label: "Check Card Balance",
        path: "/card-issuing/check-card-balance",
        module: MOD_CARD_BALANCE,
        permission: { [MOD_CARD_BALANCE]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <CheckCardBalance />,
      },
      {
        label: "Replace Cards",
        path: "/card-issuing/replace-cards",
        module: MOD_REPLACE_CARDS,
        permission: { [MOD_REPLACE_CARDS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <ReplaceCards />,
      },
      {
        label: "Combine Cards",
        path: "/card-issuing/combine-cards",
        module: MOD_COMBINE_CARDS,
        permission: { [MOD_COMBINE_CARDS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <CombineCards />,
      },
      {
        label: "Shift Report",
        path: "/card-issuing/shift-report",
        module: MOD_SHIFT_REPORT,
        permission: { [MOD_SHIFT_REPORT]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <ShiftReport />,
      },
      {
        label: "Kiosk Report",
        path: "/card-issuing/kiosk-report",
        module: MOD_KIOSK_REPORT,
        permission: { [MOD_KIOSK_REPORT]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <KioskReport />,
      },
    ],
  },
  {
    label: "Offices",
    icon: LocationsIcon,
    path: "/offices",
    module: MOD_OFFICE,
    permission: { [MOD_OFFICE]: "read" },
    allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
    element: <Offices />,
    children: [
      {
        label: "Shipping Addresses",
        path: "/offices/shipping-addresses",
        module: MOD_SHIPPING_ADDRESS,
        permission: { [MOD_SHIPPING_ADDRESS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <ShippingAddresses />,
      },
    ],
  },
  {
    label: "Reports",
    icon: ReportsIcon,
    path: "/reports",
    module: MOD_REPORT,
    permission: { [MOD_REPORT]: "read" },
    allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
    element: <Reports />,
  },
  {
    label: "Settings",
    icon: SettingsIcon,
    path: "/settings",
    module: MOD_USERS,
    permission: { [MOD_USERS]: "read" },
    allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
    children: [
      {
        label: "Users",
        path: "/settings/users",
        module: MOD_USERS,
        permission: { [MOD_USERS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <Users />,
      },
      {
        label: "Corporate Customers",
        path: "/settings/corporate-customers",
        module: MOD_CORPORATE_CUSTOMERS,
        permission: { [MOD_CORPORATE_CUSTOMERS]: "read" },
        allowedRoles: ["admin", "client_admin"],
        element: <CorporateCustomers />,
      },
      {
        // Admin-only and hidden, not read-only: the catalog is company-wide, so
        // an office admin or agent gets no menu entry, no route and no page.
        label: "Specialty Items",
        path: "/settings/specialty-items",
        module: MOD_SELL_SPECIALTY_ITEMS,
        permission: { [MOD_SELL_SPECIALTY_ITEMS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin"],
        element: <SellSpecialtyItems />,
      },
      {
        label: "Program Reports",
        path: "/settings/program-reports",
        module: MOD_REPORTS,
        permission: { [MOD_REPORTS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <ProgramReports />,
      },
      {
        label: "Audit Logs",
        path: "/settings/logs",
        module: MOD_AUDIT_LOGS,
        permission: { [MOD_AUDIT_LOGS]: "read" },
        allowedRoles: ["owner", "admin", "client_admin", "office_admin", "agent"],
        element: <AuditLogs />,
      },
    ],
  },
];

export const appRoutes = appModules.flatMap((mod) => {
  const parentRoute = mod.element
    ? [
        {
          module: mod.module,
          path: mod.path,
          element: mod.element,
          permission: mod.permission,
          allowedRoles: mod.allowedRoles,
        },
      ]
    : [];

  const childRoutes = (mod.children || []).map((child) => ({
    module: child.module,
    path: child.path,
    element: child.element,
    permission: child.permission,
    allowedRoles: child.allowedRoles,
  }));

  return [...parentRoute, ...childRoutes];
});
